<template>
  <div id="app">
    <Aon />
  </div>
</template>

<script>
import Aon from './pages/Aon/index.vue'

export default {
  name: 'App',
  components: {
    Aon
  }
}
</script>

<style>
body,html {
  margin: 0; padding: 0;
  /* text-align:center; */
  margin: 0 auto;
}
</style>
